import http from "../../http-common";

const imp = (data) => http.post("/FileReader/Upload", data);

export default { imp };
